/**
 * 日期工具,基于moment.js
 * 更多用法请参考：URL_ADDRESS * 更多用法请参考：https://momentjs.com/docs/#/
 */
import moment from 'moment';

/**
 * 获取当前日期
 *
 * @param format 日期格式，默认为 "YYYY-MM-DD"
 * @returns 当前日期的字符串表示
 */
export const getToday = (format = 'YYYY-MM-DD') => moment().format(format);
/**
 * 返回一个月前的日期
 *
 * @param format 日期格式，默认为 "YYYY-MM-DD"
 * @returns 返回一个月前的日期字符串
 */
export const getOneMonthAgo = (format = 'YYYY-MM-DD') => moment().subtract(1, 'month').format(format);

/**
 * 返回六个月前的日期
 *
 * @param format 日期格式，默认为 "YYYY-MM-DD"
 * @returns 返回六个月前的日期字符串
 */
export const getSixMonthsAgo = (format = 'YYYY-MM-DD') => moment().subtract(6, 'month').format(format);

export default {
    getToday,
    getOneMonthAgo,
    getSixMonthsAgo,
};
